import {
  QuantityCollapsibleStepDto,
  QuantityPerColorCollapsibleStepDto,
  QuantityPerColorStepDto,
  QuantityPerSizeCollapsibleStepDto,
  QuantityPerSizePerColorCollapsibleStepDto,
  QuantityPerSizePerColorStepDto,
  QuantityPerSizeStepDto,
  QuantityPerVariantStepDto,
  QuantityStepDto,
  StepDto,
  StepEnum,
} from '@/api-sdk';

export type Step =
  | {
      type: StepEnum;
      validationMessage?: string | null;
      valid?: boolean;
      details?: {
        valid?: boolean;
      };
    }
  | StepDto;

export type QuantityData =
  | QuantityStepDto
  | QuantityPerColorStepDto
  | QuantityPerSizeStepDto
  | QuantityPerSizePerColorStepDto
  | QuantityPerVariantStepDto;

export type QuantityCollapsibleData =
  | QuantityCollapsibleStepDto
  | QuantityPerColorCollapsibleStepDto
  | QuantityPerSizeCollapsibleStepDto
  | QuantityPerSizePerColorCollapsibleStepDto;

export type LayoutType = 'retail' | 'wholesale';

export type SummaryData = {
  colorCount: number | null | undefined;
  image: string | null | undefined;
  dimensions: string | null | undefined;
  printMethod: string | null | undefined;
  printPosition: string;
};

export enum Mode {
  DEFAULT = 'default',
  QUOTE = 'quote',
  DIGITAL_EXAMPLE = 'digital-example',
}

export enum Variant {
  DEFAULT = 'default',
  SIMPLE = 'simple',
}

export enum DateType {
  SHIPPING = 'shipping',
  DELIVERY = 'delivery',
}
